import BackgroundMediaDataTransformerBlock from '@activebrands/core-web/libs/storyblok/content/CmsDataTransformerBlock/BackgroundMediaDataTransformerBlock';
import { styled } from '@activebrands/core-web/libs/styletron';
import { getSafariCompatibleStyles } from '@activebrands/core-web/utils/get-safari-compatible-styles';
import getModuleBottomMarginStyles from '@activebrands/core-web/utils/style-functions/get-module-bottom-margin-styles';

const HeroWrapper = styled('section', ({ $isGrid }) => ({
    width: '100%',
    height: '100vh',
    ...getModuleBottomMarginStyles($isGrid),
}));

const baseStyles = {
    aspectRatio: 'var(--ratio-module-background-media)',
    width: '100%',
    maxHeight: 'calc(100vh - var(--height-header))',
    height: '100%',
};

const ContentWrapper = styled('section', ({ $isGrid }) =>
    getSafariCompatibleStyles({
        ...baseStyles,
        ...getModuleBottomMarginStyles($isGrid),
    })
);

export interface BackgroundMediaModuleProps {
    isGrid?: boolean;
    isHero?: boolean;
}

const BackgroundMediaModule = ({ isGrid = false, isHero = false, ...rest }: BackgroundMediaModuleProps) => {
    if (isHero) {
        return (
            <HeroWrapper $isGrid={isGrid}>
                <BackgroundMediaDataTransformerBlock {...rest} />
            </HeroWrapper>
        );
    }

    return (
        <ContentWrapper $isGrid={isGrid}>
            <BackgroundMediaDataTransformerBlock {...rest} />
        </ContentWrapper>
    );
};

export default BackgroundMediaModule;
